/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { navigate } from "gatsby";
import COLORS from "../../../constants/colors";
import PostImage from "../PostImage";

export const mapAlignmentToAlignItems = (alignment: string) => {
  switch (alignment) {
    case "left":
      return "flex-start";
    case "center":
      return "center";
    case "right":
      return "flex-end";
    default:
      return "flex-start";
  }
};

export const StandardConfig = {
  block: {
    normal: ({ children }: any) => (
      <Typography color={COLORS.BLACK[100]} variant="body" paragraph>
        {children}
      </Typography>
    ),
    h3: ({ children }: any) => (
      <Typography
        variant="h3"
        component="h3"
        color={COLORS.BLACK[100]}
        paragraph
      >
        {children}
      </Typography>
    ),
    h2: ({ children }: any) => (
      <Typography variant="h2" color={COLORS.BLACK[100]} paragraph>
        {children}
      </Typography>
    ),
    h1: ({ children }: any) => (
      <Typography variant="h1" color={COLORS.BLACK[100]} paragraph>
        {children}
      </Typography>
    ),
  },
  list: {
    bullet: ({ children }: any) => <ul>{children}</ul>,
  },
  listItem: {
    bullet: ({ children }: any) => (
      <Typography color={COLORS.BLACK[100]}>
        <li>{children}</li>
      </Typography>
    ),
  },
  types: {
    youtubeEmbed: ({ value: { url } }: any) => {
      return (
        <Box py="12px">
          <iframe
            style={{
              border: "0px",
              aspectRatio: "16 / 9",
              boxShadow: "0px 4px 60px 0px rgba(15, 11, 54, 0.25)",
            }}
            width="100%"
            height="100%"
            src={url}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
            allowFullScreen
          />
        </Box>
      );
    },
    interestExample: ({ value: { alignment } }) => {
      return (
        <Stack>
          <Typography
            color={COLORS.BLACK[100]}
            fontWeight={600}
            variant="bodySmall"
            textAlign={alignment}
          >
            Renteeksempel refinansering
          </Typography>
          <Typography
            color={COLORS.BLACK[100]}
            variant="bodySmall"
            paragraph
            textAlign={alignment}
          >
            147&nbsp;000&nbsp;kr over 7&nbsp;år, effektiv rente 13,59%, kostnad
            76&nbsp;101&nbsp;kr, totalt 223&nbsp;101&nbsp;kr
          </Typography>
        </Stack>
      );
    },
    linkButton: ({ value: { text, url, variant, alignment } }) => {
      return (
        <Stack py="8px" alignItems={alignment} alignContent="flex-start">
          <Button variant={variant} color="dark" onClick={() => navigate(url)}>
            {text}
          </Button>
        </Stack>
      );
    },
    image: (props: any) => <PostImage title="" {...props} />,
  },
};

export const CampaignLeadConfig = {
  block: {
    normal: ({ children }: any) => (
      <Typography variant="lead" color={COLORS.WHITE[100]}>
        {children}
      </Typography>
    ),
  },
};

export const BlackCampaignLeadConfig = {
  block: {
    normal: ({ children }: any) => (
      <Typography variant="lead" color={COLORS.BLACK[100]}>
        {children}
      </Typography>
    ),
  },
};
